import CryptoJS from 'crypto-js'
import { isAppH5 } from '@/util/appUserInfoStorage'

const webDevSecret =
  'b61724121cc7a624a9a82a839c174903c146584f90d574e5bb8aaf951ad1a809'

const appDevSecret =
  '146584f90d574e5bb8aaf951ad1a8b61724121cc7a624a9a82a839c174903c09'

const webProSecret =
  'fc54d1d58189433abcba561f69d2063fb6d097d3275c4a1bb385d387c5ee9c20'

const appProSecret =
  '503905cf15f041d68dcca2c3d0775791c933a9df72aa4be0883f6f68d3a08a46'

const getDeviceEnvSecretInfo = () => {
  const isApp = isAppH5()
  const isProd = process.env.VUE_APP_ENV_MODE === 'production'
  
  if (isApp) {
    // app
    return isProd
      ? { iss: 'app', secret: appProSecret }
      : { iss: 'app', secret: appDevSecret }
  } else {
    // web
    return isProd
      ? { iss: 'pc', secret: webProSecret }
      : { iss: 'pc', secret: webDevSecret }
  }
}

export function getSourceHeader() {
  try {
    const brand = 'VT'
    const secretInfo = getDeviceEnvSecretInfo()

    // base64url 编码函数
    const base64url = (str) => {
      return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(str))
        .replace(/=+$/, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
    }

    // JWT header
    const header = {
      alg: 'HS256',
      typ: 'JWT',
    }

    // JWT payload
    const payload = {
      iss: secretInfo.iss,
      ct: Date.now(),
      b: brand,
      iat: Math.floor(Date.now() / 1000),
    }

    // base64url 编码 header 和 payload
    const encodedHeader = base64url(JSON.stringify(header))
    const encodedPayload = base64url(JSON.stringify(payload))

    // 拼接 header.payload
    const unsignedToken = `${encodedHeader}.${encodedPayload}`

    // 获取密钥
    const secret = String(secretInfo.secret)

    // 生成 signature
    const signatureWordArray = CryptoJS.HmacSHA256(unsignedToken, secret)
    const signatureBase64 = CryptoJS.enc.Base64.stringify(signatureWordArray)
      .replace(/=+$/, '')
      .replace(/\+/g, '-')
      .replace(/\//g, '_')

    // 返回完整 JWT
    return `${unsignedToken}.${signatureBase64}`
  } catch (error) {
    console.error('Error generating source header:', error)
    return null
  }
}
